frappe.ui.form.ControlViceversaFloat = class ControlViceversaFloat extends frappe.ui.form.ControlFloat {
    make_input() {
        super.make_input();
        
        // Ensure the field always displays a positive number when focused
        this.$input.on("focus", () => {
            let value = this.get_value();
            if (value) {
                this.$input.val(Math.abs(value)); // Show positive number
            }
        });

        this.$input.on("focusout", (e) => {
            let value = this.get_input_value();
            this.parse_validate_and_set_in_model(value, e);
            this.refresh();

        });
    }

    parse(value) {
        value = this.eval_expression(value);
        let parsed_value = isNaN(parseFloat(value)) ? null : flt(value, this.get_precision());
        return parsed_value ? -Math.abs(parsed_value) : 0;  // Store negative value
    }

    format_for_input(value) {
        if (!value) return "";

        var number_format;
        if (this.df.fieldtype === "ViceversaFloat" && this.df.options && this.df.options.trim()) {
            number_format = this.get_number_format();
        }

        var formatted_value = format_number(Math.abs(value), number_format, this.get_precision()); // Show positive
        return formatted_value;
    }

    get_number_format() {
        var currency = frappe.meta.get_field_currency(this.df, this.get_doc());
        return get_number_format(currency);
    }

    get_precision() {
        // Round based on field precision or float precision, else don't round
        return this.df.precision || cint(frappe.boot.sysdefaults.float_precision, null);
    }
};

// Register the new control field
frappe.ui.form.ControlNegativeFloat = frappe.ui.form.ControlViceversaFloat;
